export const NAMESPACE = "AddInventoryModal";

export const ADD_OPTIONS = {
  IMPORT: "import",
  GENERATE: "generate"
};
